import { render, staticRenderFns } from "./NcrInvestigation.vue?vue&type=template&id=c1c7f324&"
import script from "./NcrInvestigation.vue?vue&type=script&lang=js&"
export * from "./NcrInvestigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports